export default __webpack_public_path__ + "static/media/micNotFound.4bb45dff.svg";